import json from '#shared/util/json.js';
import appError from '#shared/util/appError.js';

/**
 * Export the Vue plugin install method
 * @param {object} Vue Vue instance
 */
export const install = (Vue) => {
	try {
		const sessionStorage = window.sessionStorage;
		Vue.prototype.sessionStorage = {

			/**
			 * Set object into browser sessionStorage
			 * @param {string} key
			 * @param {object} data
			 */
			set(key, data) {
				sessionStorage.setItem(key, json.stringify(data));
			},

			/**
			 * Get data from browser sessionStorage
			 * @param {string} key
			 * @returns {object}
			 */
			get(key) {
				const storedValue = sessionStorage.getItem(key);
				return storedValue ? json.parse(storedValue) : null;
			},

			/**
			 * Remove item from browser sessionStorage
			 * @param {string} key
			 */
			remove(key) {
				sessionStorage.removeItem(key);
			}
		};
	} catch (error) {
		appError(error, {
			code: 'APP_FRONTEND_UTIL',
			origin: 'vue.sessionStorage'
		});
	}
};

export default {
	install
};
